module.exports = __webpack_public_path__ + "static/media/pg_quiz_tide_pool.82be821a.jpg";